/* eslint-disable no-unused-expressions */
import React, { useCallback, useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import Loading from 'Components/loading'
import TypeList from './type-list'
import Brand from './brand'
import CarList from './car-list'
import { IInfoProps, ISortProps } from './interface'
import moment from 'moment'

const BRAND_ID_KEY = 'side-nav-select-car'

export default function SelectCar() {
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  const [selectedId, setSelectedId] = useState<number>(-1)
  const [selectBrandName, setSelectBrandName] = useState<string>('热门推荐')
  const [hide, setHide] = useState(false)
  const [brandData, setBrandData] = useState<{
    letters?: any
    brands?: any
    [key: string]: any
  }>({})

  const selectName = useCallback((name) => {
    setSelectBrandName(name)
  }, [])

  const selectBrandId = useCallback(
    (id) => {
      setSelectedId(id)
      // eslint-disable-next-line no-unused-expressions
      window?.localStorage?.setItem(
        BRAND_ID_KEY,
        JSON.stringify({
          id,
          time: moment().unix(),
        })
      )
    },
    [setSelectedId]
  )

  const handler = React.useCallback((type, value) => {
    setHide(true)
    setTimeout(() => {
      setHide(false)
    }, 3000)
  }, [])

  useEffect(() => {
    async function init() {
      const data = await getBrandList()
      setBrandData(data)
      const { id, time } = JSON.parse(
        localStorage.getItem(BRAND_ID_KEY) || '{}'
      )
      let realId = -1
      if (time) {
        // 自然日不再同一天就舍弃
        if (
          moment(time * 1000).format('MM-DD-YYYY') ===
          moment().format('MM-DD-YYYY')
        ) {
          // less than 1 day
          realId = id
        } else {
          // over 1 day . invalid.
          localStorage.removeItem(BRAND_ID_KEY)
        }
      }
      setSelectedId(realId)
    }
    if (inView) {
      init()
    }
  }, [inView])

  useEffect(() => {
    const token = PubSub.subscribe('HIDE_HOVER_CAR', handler)
    return () => {
      PubSub.unsubscribe(token)
    }
  }, [])

  return (
    <div
      className={`select-car-content tw-w-542 xl:tw-w-864 ${
        hide ? 'tw-hidden' : ''
      }`}
      ref={ref}
      onClick={(e) => e.stopPropagation()}
    >
      <TypeList />
      <div className="select-brand-wrap tw-pt-60">
        {brandData?.letters?.length && brandData?.brands?.length ? (
          <>
            <div className="brand-list">
              <Brand
                letters={brandData.letters}
                brands={brandData.brands}
                selectBrandId={selectBrandId}
                selectBrandName={selectName}
                brandId={selectedId}
              />
            </div>
            <div className="car-list">
              <CarList id={selectedId} name={selectBrandName} />
            </div>
          </>
        ) : (
          <div className="bg-loading">
            <Loading />
          </div>
        )}
      </div>
      <style jsx>
        {`
          .select-car-content {
            z-index: 1000;
            background: #fff;
            height: 100%;
            padding: 20px 0 0 20px;
          }
          .select-brand-wrap {
            height: 100%;
            display: flex;
          }
          .bg-loading {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
          .brand-list {
            width: 205px;
          }
          .car-list {
            position: relative;
            flex: 1;
          }
        `}
      </style>
    </div>
  )
}

// 重新处理数据
function reHandleData(data: any) {
  // 处理品牌
  let list: IInfoProps[] = []
  const brands: IInfoProps[][] = []
  const letters: string[] = []
  // eslint-disable-next-line no-unused-expressions
  data?.brand?.forEach((item: IInfoProps) => {
    if (item.type === 1000) {
      letters.push(item.info.pinyin)
      brands.push(list)
      list = []
    }
    if (item.type === 1000 || item.type === 1001) {
      list.push(item)
    }
  })
  brands.push(list)
  brands.shift()
  return {
    letters: ['*', ...letters],
    brands: [
      [
        {
          info: {
            pinyin: '*',
            brand_name: '热门推荐',
            image_url: '',
            brand_id: -1,
          },
          type: -1,
        },
      ],
      ...brands,
    ],
  }
}

async function getBrandList() {
  const res = await fetch('/motor/pc/car/brand/all_brand')
  const json = await res.json()
  return reHandleData(json.data) || {}
}
